import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import { Link } from "react-router-dom";
import moment from "moment";
import { orderStatus } from "../../Components/constants/layout";
import SalesChannels from "../../Components/Common/SalesChannels";
import { Typography } from "@mui/material";
import RestrictedChannels from "../../Components/Common/RestrictedChannels";

const OrderDetail = ({
  show,
  onRefoundClick,
  onCancelClick,
  onCloseClick,
  orders,
}) => {
  const [isPatialRefund, setIsPartialRefund] = useState(false);
  const [newQuantity, setNewQuantity] = useState(orders?.ord_quantity);
  const [showRefund, setShowRefund] = useState(false);

  const getStatus = () => {
    if (orders?.ord_cancellationReason) {
      return (
        <span
          style={{ width: "100px" }}
          className="badge text-uppercase text-dark bg-danger"
        >
          Cancelled
        </span>
      );
    }
    switch (orders?.ord_status) {
      case orderStatus.STATUS_ORDERED:
        return (
          <span className="badge text-uppercase text-dark bg-success">
            ordered
          </span>
        );
      case orderStatus.STATUS_CANCELLED:
        return (
          <span className="badge text-uppercase text-dark bg-danger">
            cancelled{" "}
          </span>
        );
      case orderStatus.STATUS_EXPIRED:
        return (
          <span className="badge text-uppercase text-dark bg-warning">
            {" "}
            EXPIRED
          </span>
        );
      default:
        return <span></span>;
    }
  };
  useEffect(() => {
    if (orders?.ord_quantity) {
      setNewQuantity(orders?.ord_quantity);
    }
  }, [orders]);

  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="xl">
      <Modal
        isOpen={showRefund}
        toggle={() => setShowRefund(false)}
        centered={true}
        size="xl"
      >
        <ModalHeader toggle={() => setShowRefund(false)} className="bg-light">
          <h5 className="modal-title mt-0">Order Refund</h5>
        </ModalHeader>
        <ModalBody>
          <Container fluid>
            <Row>
              <Col>
                <div className="d-sm-flex align-items-center mb-2">
                  <div className="d-flex flex-column">
                    <div className="form-check mb-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="partialRefundCheckbox"
                        checked={isPatialRefund}
                        onChange={(e) => {
                          setIsPartialRefund(e.target.checked);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="partialRefundCheckbox"
                      >
                        This is a Partial Refund
                      </label>
                    </div>
                    {isPatialRefund ? (
                      <>
                        <label htmlFor="newQuantity" className="form-label">
                          New Quantity:
                        </label>
                        <input
                          max={orders?.ord_quantity || 0}
                          min={0}
                          type="number"
                          id="newQuantity"
                          className="form-control"
                          placeholder="Enter new quantity"
                          value={newQuantity}
                          onChange={(e) => {
                            setNewQuantity(e.target.value);
                          }}
                        />

                        <div className="mt-3">
                          <b>Old Price: </b>
                          {orders?.ord_totalPrice?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </div>
                        <div className="mt-3">
                          <b>New Price: </b>
                          {(
                            (orders?.ord_totalPrice / orders?.ord_quantity) *
                            newQuantity
                          ).toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </div>
                        <div className="mt-3">
                          <b>Refund Amount: </b>
                          <span className="text-danger">
                            {(
                              orders?.ord_totalPrice -
                              (orders?.ord_totalPrice / orders?.ord_quantity) *
                                newQuantity
                            ).toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })}
                          </span>
                        </div>
                      </>
                    ) : (
                      <div className="mt-3">
                        <b>Refund Amount: </b>
                        <span className="text-danger">
                          {orders?.ord_totalPrice?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
            onClick={() => setShowRefund(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-success"
            data-bs-dismiss="modal"
            onClick={() => {
              onRefoundClick(orders, isPatialRefund ? newQuantity : 0);
              setShowRefund(false);
            }}
          >
            Refund
          </button>
        </ModalFooter>
      </Modal>

      <div className="modal-header">
        <h5 className="modal-title mt-0">Order Details</h5>
        <button
          onClick={onCloseClick}
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <Container fluid>
          <Row>
            <Col>
              <div className="d-sm-flex align-items-center mb-2">
                {!orders?.ord_cancellationReason &&
                  orders?.ord_status != 5 &&
                  orders?.ord_status != 4 && (
                    <div className="flex-shrink-0 mt-2 mt-sm-0 ms-1">
                      <Link
                        to="#"
                        onClick={() => onCancelClick(orders)}
                        className="btn btn-soft-danger btn-sm mt-2 mt-sm-0"
                      >
                        <i className="mdi mdi-archive-remove-outline align-middle me-1"></i>{" "}
                        Cancel Order
                      </Link>
                    </div>
                  )}
                {(orders?.ord_status == orderStatus.STATUS_ORDERED ||
                  orders?.ord_status == orderStatus.STATUS_SHIPPED) && (
                  <div className="flex-shrink-0 mt-2 mt-sm-0 ms-1 ">
                    <Link to="#" className="btn btn-soft-success btn-sm">
                      <i className="ri-download-2-fill align-middle me-1"></i>{" "}
                      Invoice
                    </Link>
                  </div>
                )}
                {orderStatus.STATUS_ORDERED == orders?.ord_status && (
                  <div className="flex-shrink-0 mt-2 mt-sm-0 ms-1">
                    <Link
                      to="#"
                      onClick={() => setShowRefund(true)}
                      className="btn btn-soft-danger btn-sm mt-2 mt-sm-0"
                    >
                      <i className="mdi mdi-credit-card-refund-outline align-middle me-1"></i>
                      Refund
                    </Link>
                  </div>
                )}
              </div>
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center">
                    <h5 className="card-title flex-grow-1 mb-0">
                      Order # {orders?.ord_id}
                    </h5>

                    <div className="flex-shrink-0">{getStatus()}</div>
                  </div>
                  {orders?.ord_cancellationReasonText != null && (
                    <div className="mt-2">
                      <p className="text-muted mb-0">
                        <b>Cancellation Reason:</b>{" "}
                        {orders?.ord_cancellationReasonText}
                      </p>
                    </div>
                  )}
                </CardHeader>
                <CardBody>
                  <div className="flex-grow-1 ms-3">
                    <Row>
                      <div>
                        <b>Ordered Date: </b>
                        {moment(orders?.ord_dateCreated).format(
                          "MM/DD/YYYY, h:mm a"
                        )}
                      </div>
                    </Row>
                    {orders?.ord_datePurchaseOrder && (
                      <Row>
                        <div>
                          <b>Purchased Date: </b>
                          {moment(orders?.ord_datePurchaseOrder).format(
                            "MM/DD/YYYY, h:mm a"
                          )}
                        </div>
                      </Row>
                    )}
                    <Row>
                      <div>
                        <b>Quantity: </b>
                        {orders?.ord_quantity}
                      </div>
                    </Row>
                    <Row>
                      <div>
                        <b>Price: </b>
                        {orders?.ord_totalPrice?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                      </div>
                    </Row>
                    <Row>
                      <div>
                        <b>Extended Lead Time: </b>
                        {orders?.ord_extendedLeadTime
                          ? `${orders.ord_extendedLeadTime} days`
                          : "N/A"}
                      </div>
                    </Row>
                    <Row>
                      <div>
                        {" "}
                        <b>MAP (Minimum Advertised Price): </b>
                        {orders?.ord_MAP &&
                          orders.ord_MAP.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                      </div>
                    </Row>
                    <Row className="mt-1">
                      <div>
                        <b>Sales Channel: </b>
                        <SalesChannels channel={orders?.ord_salesChannel} />
                      </div>
                    </Row>
                    <Row className="mt-1">
                      <div>
                        <b>Restricted Channel: </b>
                        <RestrictedChannels
                          channel={
                            orders?.ord_restrictedChannel ||
                            orders?.ordRestrictedChannel
                          }
                        />
                      </div>
                    </Row>
                    <Row className="mt-1">
                      <div>
                        <b>Important notes:</b>
                        <Typography variant="body2" color="textSecondary">
                          {orders?.ord_importantNotes}
                        </Typography>
                      </div>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <div className="d-sm-flex align-items-center">
                    <h5 className="card-title flex-grow-1 mb-0">
                      Product Detail
                    </h5>
                  </div>
                </CardHeader>
                <CardBody>
                  <div className="flex-grow-1 ms-3">
                    <Row>
                      <a href={orders?.productURL} target="_blank">
                        <h5>
                          {" "}
                          <b>{orders?.productName}</b>
                        </h5>
                      </a>
                    </Row>
                    <Row>
                      <div>
                        <b>Product Codes: </b>
                        <span>
                          {orders?.productUPC
                            ? orders?.productUPC
                            : "No UPC Code"}
                          {orders?.productASIN && (
                            <span> / {orders?.productASIN}</span>
                          )}
                        </span>
                      </div>
                    </Row>
                    <Row>
                      <div>
                        <b>Supplier: </b>
                        {orders?.supplierName}{" "}
                      </div>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {orders?.ord_importantNotes && (
            <Row className="mt-3">
              <Col>
                <Card>
                  <CardHeader>
                    <h5 className="card-title mb-0">Important Notes</h5>
                  </CardHeader>
                  <CardBody>
                    <div className="flex-grow-1 ms-3">
                      <p>{orders.ord_importantNotes}</p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={onCloseClick}
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default OrderDetail;
